<template>
  <Box>
    <h2 class="box__title">{{ $t(`${namespace}.title`) }}</h2>
    <Chart :data="data" />
  </Box>
</template>

<script>
import Chart from './Chart'

export default {
  name: 'ChartBox',
  props: {
    data: {
      type: Object
    }
  },
  components: {
    Chart
  },
  data () {
    return {
      namespace: 'Components.Performance'
    }
  }
}
</script>

<style lang="scss" scoped>
.box__title {

  @media (min-width: 961px) {
    position: absolute;
    left: 16px;
    top: 16px;
    z-index: 1;
  }
}
</style>
